'use client';
import { jsx } from 'react/jsx-runtime';
import t from 'prop-types';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

let r = {
    skin: t.oneOf([
        'standard',
        'button-menu'
    ])
}, a = Object.keys(r);
const LeftHandNavigation = renderWithRef('LeftHandNavigation', r, (t, o)=>{
    let { children: r, skin: s = 'standard' } = t, d = new Set([
        'swan-lhn'
    ]);
    return s && 'standard' !== s && d.add(`swan-lhn-skin-${s}`), jsx(RenderComp, {
        root: "nav",
        forwardedRef: o,
        classNames: d,
        props: t,
        propKeysToRemove: a,
        children: r
    });
});

export { LeftHandNavigation };
